export default function ContactUs() {
  return (
    <main style={{ padding: "40px", maxWidth: "1000px", margin: "auto" }}>
      <h1>Contact Us</h1>

      <iframe
        src="https://merchant.razorpay.com/policy/S2KjQ8ckWXnkCw/contact_us"
        title="Contact Us"
        width="100%"
        height="800"
        style={{ border: "none" }}
      />
    </main>
  );
}